<template>
  <div class="hello">
    <el-button @click="gotoLogin" type="danger" class="go-to-login" size="small">退出</el-button>
    <div class="title">
      <img :src="img" alt="" width="140" height="40" style="vertical-align:middle; margin: -8px 10px 0 0" />
      {{ msg }}
    </div>
    <div class="body">
      <template v-for="(nav, navIndex) in navList">
        <el-row :gutter="20" :key="navIndex">
          <div class="to-title" v-if="type === 'yx'">{{ nav.title }}</div>
          <template v-for="(item, index) in nav.data">
            <el-col :span="6" :key="index">
              <template v-if="item.type === 'nav'">
                <div class="form" style="background: #FFF" @click="getUrl(item)">
                  <span class="img">{{ item.name.slice(0, 1) }}</span>
                  <span class="form-name" :title="item.name">{{ item.name }}</span>
                </div>
              </template>
              <template v-else-if="item.type === 'platform'">
                <div class="form" style="background: #FFF" @click="getPlatform(item)">
                  <span class="img">{{ item.name.slice(0, 1) }}</span>
                  <span class="form-name" :title="item.name">{{ item.name }}</span>
                </div>
              </template>
              <template v-else-if="item.type === 'file'">
                <a :href="'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(item.url)"
                  target="_blank">
                  <div class="form" style="background: #FFF">
                    <span class="img">{{ item.name.slice(0, 1) }}</span>
                    <span class="form-name" :title="item.name">{{ item.name }}</span>
                  </div>
                </a>
              </template>
              <template v-else-if="item.type === 'pdf'">
                <a :href="origin + '?type=pdf' + '&src=' + encodeURIComponent(item.url)" target="_blank">
                  <div class="form" style="background: #FFF">
                    <span class="img">{{ item.name.slice(0, 1) }}</span>
                    <span class="form-name" :title="item.name">{{ item.name }}</span>
                  </div>
                </a>
              </template>
              <template v-else-if="item.type === 'token'">
                <div class="form" style="background: #FFF" @click="getUrl(item)">
                  <span class="img">{{ item.name.slice(0, 1) }}</span>
                  <span class="form-name" :title="item.name">{{ item.name }}</span>
                </div>
              </template>
            </el-col>
          </template>
        </el-row>
      </template>
    </div>
    <el-dialog :title="name" :visible.sync="show" width="30%" :close-on-click-modal="false">
      <el-select filterable default-first-option v-model="platform" placeholder="选择站台" style="width: 100%">
        <el-option :label="item.name" :value="item.code" v-for="(item, key) in platformList" :key="key">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>
    <LookUrl ref="lookUrlRef" />
  </div>
</template>

<script>
import LookUrl from "@/components/lookUrl.vue";

export default {
  name: 'helloWord',
  data() {
    return {
      navList: [],
      msg: '欢迎使用互链时空网址导航',
      show: false,
      platform: '',
      url: '',
      platformList: [],
      img: require('@/assets/hlsk.png'),
      name: '',
      type: '',
      origin: window.location.origin
    }
  },
  components: { LookUrl },
  mounted() {
    this.type = localStorage.getItem('type')
    if (this.type === 'nb') {
      this.msg = '欢迎使用互链时空网址导航'
    } else if (this.type === 'ceo') {
      this.msg = 'CEO驾驶舱'
    } else {
      this.msg = '工具箱导航'
    }
    this.$axios.get('/account/menu/getListUrls').then(res => {
      this.navList = []
      if (this.type === 'nb') {
        this.navList = [
          {
            title: '网址导航',
            data: res.data.data.filter((item) => {
              return item.code === '网址导航'
            })
          }
        ]
      } else if (this.type === 'ceo') {
        this.navList = [
          {
            title: '驾驶舱',
            data: res.data.data.filter((item) => {
              return item.code === 'ceo'
            })
          }
        ]
      } else {
        let codeList = [...new Set(res.data.data.map((item) => {
          return item.code
        }))]
        let codes = codeList.filter(item => {
          return item !== '网址导航' && item !== 'ceo'
        })
        this.navList = []
        codes.forEach((code) => {
          this.navList.push({
            title: code,
            data: res.data.data.filter((item) => {
              return item.code === code
            })
          })
        })
      }
      this.navList.forEach((nav) => {
        nav.data.forEach((item) => {
          item['isOss'] = item.url && (item.url.indexOf('oss.wechain360') !== -1 || item.url.indexOf('hulianuat.oss-cn-beijing.aliyuncs.com') !== -1);
        })
      })
    })
  },
  methods: {
    getPlatform(item) {
      this.$axios.get('/account/platform/all').then(res => {
        this.platformList = res.data.data
        this.url = item.url
        this.show = true
        this.platform = ''
        this.name = item.name + '--选择站台'
      })
    },
    getUrl(item) {
      if (item.url) {
        let a = document.createElement('a')
        if (item.type === 'token' && item.url.indexOf('?') !== -1) {
          a.href = item.url + `&token=${localStorage.getItem('token')}`
        } else if (item.type === 'token' && item.url.indexOf('?') === -1) {
          a.href = item.url + `?token=${localStorage.getItem('token')}`
        } else {
          a.href = item.isOss ? item.url + '?radmio=' + Math.random() : item.url
        }
        a.setAttribute("target", "_blank");
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }
      // if (item.url) {
      //     let str = "width=900,height=500,top=100,left=300,location=no,status=no,scrollvars=no"
      //     window.open(item.isOss ? item.url + '?radmio=' + Math.random() : item.url, item.name, str);
      // }
    },
    save() {
      let a = document.createElement('a')
      a.href = this.url + '?platformName=' + this.platform
      a.setAttribute("target", "_blank");
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      this.show = false
    },
    gotoLogin() {
      localStorage.removeItem('token')
      this.$message.success({ showClose: true, message: '退出登录成功' })
      this.$router.replace({ name: 'login' })
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.title {
  font-size: 28px;
  padding: 30px 0;
  text-align: center;
  color: #fff;
  font-weight: bold;
}

.hello {
  color: #606266;
  height: 100%;
  width: 100%;
  background: url('../assets/background.jpeg') no-repeat;
  background-size: 100% 100%;
}

.body {
  width: 942px;
  height: 80%;
  overflow: auto;
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid #EBEEF5;
  color: #303133;
  border-radius: 5px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
  text-align: left;
}

.form {
  display: flex;
  height: 50px;
  margin: 10px 0;
  background: #fff;
  align-items: center;
  border-radius: 5px;
  padding-left: 10px;
  font-weight: bold;
  color: #606266;
  cursor: pointer
}

.form:hover {
  color: #409EFF;
}

.img {
  width: 30px;
  height: 30px;
  background: #409EFF;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  margin-right: 10px;
}

.form-name {
  width: calc(100% - 44px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

a {
  color: #606266;
  text-decoration: none
}

.go-to-login {
  position: fixed;
  right: 40px;
  top: 30px;
}

.to-title {
  color: #fff;
  font-size: 18px;
  margin: 5px 10px;
  padding-left: 5px;
  border-left: 8px solid #409eff;
  font-weight: bold;
}
</style>
